import { TComputedPropMapper } from '../../../types/computed-props-mapper';

export const getAuctionMinBet: TComputedPropMapper<number> = ({ offer: { auction, geo } }, { config }) => {
  const regionId = geo && geo.address && geo.address.length ? geo.address[0].id : 0;
  const auctionMinBetForMoscowRegion = Number(config.get<string>('auction.minBetForMoscowRegion'));
  const isMoscowRegion = [1, 4593].includes(regionId);

  return isMoscowRegion ? auctionMinBetForMoscowRegion : 1;
};
